import { Button, Toast, Modal } from 'dingtalk-design-mobile'
import './InformationDetail.less'
import { useSearchParams } from 'react-router-dom'
import copy from 'copy-to-clipboard'

const InformationDetail = () => {
  const [ params ] = useSearchParams()
  const prevId = params.getAll('id')[0]

  // const handleClick = () => {
  //   const url = prevId === '1' ? 
  //   'https://xfw-benefitfulwork.oss-cn-hangzhou.aliyuncs.com/file/%E5%85%B3%E4%BA%8E%E5%AE%9E%E6%96%BD%E5%B0%8F%E9%A2%9D%E7%BC%B4%E8%B4%B9%E5%B7%A5%E4%BC%9A%E7%BB%84%E7%BB%87%E5%B7%A5%E4%BC%9A%E7%BB%8F%E8%B4%B9%E5%85%A8%E9%A2%9D%E8%BF%94%E8%BF%98%E6%94%AF%E6%8C%81%E6%94%BF%E7%AD%96%E7%9A%84%E9%80%9A%E7%9F%A5.zip' :
  //   'https://xfw-benefitfulwork.oss-cn-hangzhou.aliyuncs.com/file/%E4%B8%AD%E5%B7%A5%E6%80%BB%E5%AD%97%5B2018%5D6%E5%8F%B7%20%E5%85%B3%E4%BA%8E%E8%BD%AC%E5%8F%91%E3%80%8A%E4%B8%AD%E5%8D%8E%E5%85%A8%E5%9B%BD%E6%80%BB%E5%B7%A5%E4%BC%9A%E5%8A%9E%E5%85%AC%E5%8E%85%E5%85%B3%E4%BA%8E%E5%8D%B0%E5%8F%91%E3%80%8A%E5%9F%BA%E5%B1%82%E5%B7%A5%E4%BC%9A%E7%BB%8F%E8%B4%B9%E6%94%B6%E6%94%AF%E7%AE%A1%E7%90%86%E5%8A%9E%E6%B3%95%E3%80%8B%E7%9A%84%E9%80%9A%E7%9F%A5%E3%80%8B%E7%9A%84%E9%80%9A%E7%9F%A5.pdf'
  //   Toast.success({
  //     content: '复制成功',
  //     duration: 2
  //   })
  //   copy(url)
  // }

  const handleClick = () => {
    const url = prevId === '1' ? 
    'https://xfw-benefitfulwork.oss-cn-hangzhou.aliyuncs.com/file/%E5%85%B3%E4%BA%8E%E5%AE%9E%E6%96%BD%E5%B0%8F%E9%A2%9D%E7%BC%B4%E8%B4%B9%E5%B7%A5%E4%BC%9A%E7%BB%84%E7%BB%87%E5%B7%A5%E4%BC%9A%E7%BB%8F%E8%B4%B9%E5%85%A8%E9%A2%9D%E8%BF%94%E8%BF%98%E6%94%AF%E6%8C%81%E6%94%BF%E7%AD%96%E7%9A%84%E9%80%9A%E7%9F%A5.zip' :
    'https://xfw-benefitfulwork.oss-cn-hangzhou.aliyuncs.com/file/%E4%B8%AD%E5%B7%A5%E6%80%BB%E5%AD%97%5B2018%5D6%E5%8F%B7%20%E5%85%B3%E4%BA%8E%E8%BD%AC%E5%8F%91%E3%80%8A%E4%B8%AD%E5%8D%8E%E5%85%A8%E5%9B%BD%E6%80%BB%E5%B7%A5%E4%BC%9A%E5%8A%9E%E5%85%AC%E5%8E%85%E5%85%B3%E4%BA%8E%E5%8D%B0%E5%8F%91%E3%80%8A%E5%9F%BA%E5%B1%82%E5%B7%A5%E4%BC%9A%E7%BB%8F%E8%B4%B9%E6%94%B6%E6%94%AF%E7%AE%A1%E7%90%86%E5%8A%9E%E6%B3%95%E3%80%8B%E7%9A%84%E9%80%9A%E7%9F%A5%E3%80%8B%E7%9A%84%E9%80%9A%E7%9F%A5.pdf'
    
    Modal.alert(
      '',
      '请用手机浏览器打开链接下载资料',
      [
        { text: '取消', onClick: () => {} },
        { text: '复制链接', onClick: () => {
          Toast.success({
            content: '复制成功',
            duration: 2
          })
          copy(url)
        } },
      ]
    )
  }

  return (
    <div className="pg-information-detail">
      <img className='detial-img' src={`https://xfw-benefitfulwork.oss-cn-hangzhou.aliyuncs.com/information/detail-0${prevId}.png`} />
      <div className='btn--wrap'>
        <Button className='btn' onClick={handleClick}>下载文件</Button>
      </div>
    </div>
  )
}

export default InformationDetail